import './assets/main.css'
import VConsole from 'vconsole'

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

const app = createApp(App)

app.use(router)

// 只在開發環境中啟用
if (process.env.NODE_ENV === 'development') {
  new VConsole()
}

app.mount('#app')
